import React, { Component } from "react";

class Account extends Component {
  render() {
    return <div>Account Page Here</div>;
  }
}

export default Account;
